import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import SubMenu from "../../../../components/SubMenu";
import Layout from "../../../../layout";
import BasicInfo from "./BasicInfo";
import ProfileLayout from "../Layout";
import About from "./About";
import Education from "./Education";
import Skills from "./Skills";
import Resume from "./Resume";
import { getIndustryAction } from "../../../../redux/actions/industryActions";
import { getProfileAction } from "../../../../redux/actions/profileActions";
import { getCountryAction } from "../../../../redux/actions/countryActions";
import { getStateAction } from "../../../../redux/actions/stateActions";
import { PageLoader } from "../../../../components/PageLoader";
import {
  getAllSkillsAction,
  getMySkillsAction,
} from "../../../../redux/actions/skillsAction";
import {
  getAllEducationAction,
  getSingleEducationAction,
} from "../../../../redux/actions/educationActions";
import Experience from "./Experience";
import { 
  Menu, 
  MenuItem, 
  Button,
  ListItemText,
  useTheme,        // <--- 1. Import useTheme
  useMediaQuery    // <--- 2. Import useMediaQuery
} from "@material-ui/core";
import { ExpandMore, Menu as MenuIcon } from "@material-ui/icons";

const subMenuOptions = [
  ["basic info", "/profile/edit/basic"],
  ["about", "/profile/edit/about"],
  ["education", "/profile/edit/education"],
  ["skills", "/profile/edit/skills"],
  ["experience", "/profile/edit/experience"],
  ["resume", "/profile/edit/resume"],
];

const EditProfile = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  
  // 3. Define the theme and mobile check
  const theme = useTheme();
  // We use 'sm' here because your sidebar hides at 'md' (d-md-none)
  const isMobileView = useMediaQuery(theme.breakpoints.down("sm")); 

  const { educationId } = useParams();
  const { industry, profile, country, state, education, skill } = useSelector(
    (store) => store
  );
  const { industries } = industry;
  const { profileData, profileLoading } = profile;
  const { educationData, educationLoading } = education;
  const { countries } = country;
  const { states } = state;
  const { allSkills, skillLoading, mySkills } = skill;
  console.log("profileData", profileData);
  const basicInfoProps = {
    industries,
    profileData,
    countries,
    states,
    profileLoading,
  };

  const aboutProps = {
    profileData,
    profileLoading,
  };

  const educationProps = {
    educationData,
    educationLoading,
    isEdit: !!educationId,
    educationId: educationId ?? "",
  };

  const skillProps = {
    allSkills,
    skillLoading,
    mySkills,
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  
  const getCurrentMenuItem = () => {
    const current = subMenuOptions.find(([_, path]) => pathname.includes(path));
    return current ? current[0] : "Menu";
  };

  useEffect(() => {
    Promise.resolve(getProfileAction(dispatch)).then(({ payload }) => {
      const countryId = payload?.country;
      const promises = [
        getIndustryAction(dispatch),
        getCountryAction(dispatch),
        getAllSkillsAction(dispatch),
        getMySkillsAction(dispatch),
        getAllEducationAction(dispatch),
      ];
      if (countryId) {
        promises.push(getStateAction(countryId, dispatch));
      }
      Promise.all(promises).finally(() => {
        setIsLoading(false);
        console.log(" =====educationDataValue::: " + educationId);
      });
    });
  }, [dispatch]);

  useEffect(() => {
    if (educationId) {
      Promise.resolve(getSingleEducationAction(educationId, dispatch)).finally(
        () => {
          setIsLoading(false);
        }
      );
    }
  }, [dispatch, educationId]);

  return (
    <Layout>
      {isLoading ? (
        <PageLoader />
      ) : (
        <ProfileLayout>
          <div className="section-header mt-5">
            <p className="mb-0">Edit Profile</p>
          </div>
          <div className="d-flex flex-column flex-md-row mt-3">
            {/* Mobile Dropdown Menu */}
            <div className="d-md-none mb-3">
              <Button
                variant="contained"
                onClick={handleMenuClick}
                style={{ 
                  width: '100%', 
                  backgroundColor: '#3a6ed4',
                  color: '#fff',
                  padding: '12px 16px',
                  fontSize: '16px',
                  fontWeight: '500',
                  textTransform: 'none',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  border: 'none',
                  justifyContent: 'space-between'
                }}
                endIcon={<ExpandMore style={{ color: '#fff' }} />}
              >
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <MenuIcon style={{ marginRight: '8px', fontSize: '20px' }} />
                  {getCurrentMenuItem()}
                </span>
              </Button>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                PaperProps={{
                  style: {
                    width: '100%',
                    marginTop: '8px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    border: '1px solid rgba(0,0,0,0.1)'
                  }
                }}
              >
                {subMenuOptions.map(([label, path]) => (
                  <MenuItem 
                    key={path} 
                    onClick={() => {
                      window.location.href = path;
                      handleMenuClose();
                    }}
                    selected={pathname.includes(path)}
                    style={{
                      padding: '12px 16px',
                      fontSize: '14px',
                      borderBottom: pathname.includes(path) ? '2px solid #3a6ed4' : 'none',
                      backgroundColor: pathname.includes(path) ? 'rgba(58, 110, 212, 0.08)' : 'transparent'
                    }}
                  >
                    <ListItemText 
                      primary={label} 
                      primaryTypographyProps={{
                        style: {
                          fontWeight: pathname.includes(path) ? '600' : '400',
                          color: pathname.includes(path) ? '#3a6ed4' : '#333'
                        }
                      }}
                    />
                  </MenuItem>
                ))}
              </Menu>
            </div>
            
            {/* Desktop Sidebar Menu */}
            <div className="d-none d-md-block mb-3 mb-md-0" style={{ flex: '0 0 20%', maxWidth: '20%' }}>
              <SubMenu menuOptions={subMenuOptions} />
            </div>
            
            {/* 4. Fix: Conditional Width based on isMobileView */}
            <div 
              className="w-100 pl-md-4" 
              style={{ 
                flex: isMobileView ? '0 0 100%' : '0 0 80%', 
                maxWidth: isMobileView ? '100%' : '80%' 
              }}
            >
              {pathname.includes("basic") && <BasicInfo {...basicInfoProps} />}
              {pathname.includes("about") && <About {...aboutProps} />}
              {pathname.includes("education") && (
                <Education {...educationProps} />
              )}
              {pathname.includes("skills") && <Skills {...skillProps} />}
              {pathname.includes("resume") && <Resume />}
              {pathname.includes("experience") && <Experience />}
            </div>
          </div>
        </ProfileLayout>
      )}
    </Layout>
  );
};

export default EditProfile;